<template>
    <div :class="row ? 'product--row' : ''" class="product">
        <div class="product__image" @click="$emit('hideMenu')">
            <!-- Link -->
            <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" :href="item.url" class="img-container">
                <ImagePreview
                    :blure="item.attributes.isForAdultsOnly"
                    :image-url="item.imageCdn || item.img || item.image"
                    :image-alt="item.value"
                />
                <div v-if="item.percentDiscount" class="product-discount discount">-{{ item.percentDiscount }} %</div>

                <div v-if="item.visualTags" class="product-badges" :class="row ? 'product-badges--promo' : ''">
                    <div
                        v-for="(item, index) in item.visualTags.productVisualTagsBadges"
                        :key="index"
                        :badge-id="item.id"
                        class="item"
                        :style="{ 'background-color': item.backgroundColor, color: item.textColor }"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </a>
            <a v-else :href="item.url" class="img-container">
                <ImagePreview
                    :blure="item.attributes.isForAdultsOnly"
                    :image-url="item.imageCdn || item.img || item.image"
                    :image-alt="item.value"
                />
                <div v-if="item.percentDiscount" class="product-discount discount">-{{ item.percentDiscount }} %</div>

                <div v-if="item.visualTags" class="product-badges" :class="row ? 'product-badges--promo' : ''">
                    <div
                        v-for="(item, index) in item.visualTags.productVisualTagsBadges"
                        :key="index"
                        :badge-id="item.id"
                        class="item"
                        :style="{ 'background-color': item.backgroundColor, color: item.textColor }"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </a>
            <!-- endLink -->
        </div>
        <div class="product__content">
            <div @click="$emit('hideMenu')">
                <!-- Link -->
                <a
                    @click.prevent="$emit('redirectToUrl', $event)"
                    v-if="isPwa"
                    class="product__name"
                    :href="item.url"
                    :title="item.value || item.name"
                >
                    <span class="h3">{{ item.value || item.name || item.title }}</span>
                </a>
                <a v-else class="product__name" :href="item.url" :title="item.value || item.name">
                    <span class="h3">{{ item.value || item.name || item.title }}</span>
                </a>
                <!-- endLink -->
            </div>

            <p v-if="showDesc" class="product__desc mb-0">{{ item.description || item.info }}</p>

            <a
                :href="item.url"
                v-if="!item.isService"
                class="product__availability"
                :class="item.availabilityTextColor ? `stock text-${item.availabilityTextColor}` : 'stock text-success'"
                @click.stop="visible = true"
                v-html="item.availability || item.availabilityText || '&nbsp;'"
            ></a>

            <div @click="$emit('hideMenu')">
                <!-- Link -->
                <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" :href="item.url" class="product__price">
                    <s v-if="item.priceBeforeDiscount" v-html="$formatCurrency(item.priceBeforeDiscount)" class="old me-1"></s>
                    <s v-if="item.rrp" v-html="$formatCurrency(item.rrp)" class="old me-1"></s>
                    <b v-if="item.priceFrom" v-html="`${dictionary.from} ${$formatCurrency(item.priceFrom)}`"></b>
                    <b v-else v-html="$formatCurrency(item.price)"></b>
                </a>
                <a v-else :href="item.url" class="product__price">
                    <s v-if="item.priceBeforeDiscount" v-html="$formatCurrency(item.priceBeforeDiscount)" class="old me-1"></s>
                    <s v-if="item.rrp" v-html="$formatCurrency(item.rrp)" class="old me-1"></s>
                    <b v-if="item.priceFrom" v-html="`${dictionary.from} ${$formatCurrency(item.priceFrom)}`"></b>
                    <b v-else v-html="$formatCurrency(item.price)"></b>
                </a>
                <!-- endLink -->
            </div>
            <div>
                <AddBasket
                    :dictionary="dictionary"
                    :product="item"
                    @addProductToBasket="addProductToBasket"
                    :basket-amount="basketAmount"
                    item-list-name="Header_product"
                />
            </div>
            <div v-if="Object.keys(item.giftActions).length > 0" class="product__gift">
                <div v-for="(item, index) in item.giftActions" :key="index" class="gift-actions">
                    <span :title="item.title">
                        <strong> {{ item.header }}:</strong> {{ item.title }}
                    </span>

                    <i width="12" height="12" class="d-none d-sm-inline ico ico--info ms-1"> </i>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import ImagePreview from './ImagePreview.vue'
import AddBasket from './AddBasket'

export default {
    components: {
        ImagePreview,
        AddBasket,
    },
    props: {
        basketAmount: {
            type: Number,
            required: true,
        },
        isPwa: {
            type: Boolean,
            required: true,
        },
        item: {
            type: Object,
        },
        row: {
            type: Boolean,
            default: false,
        },
        showDesc: {
            type: Boolean,
            default: false,
        },
        dictionary: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            rating: 5,
            ratingShowStar: 3,
            visible: false,
        }
    },

    methods: {
        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },
    },
}
</script>

<style lang="scss">
.adults-only {
    opacity: 0.5;
}
.menu-item .product,
.menu__item .product {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    font-size: 14px;
    padding: 1.5em 1em;
    transition: 150ms ease-in-out;
    border-radius: 10px;
    text-align: center;
    margin: 0 6px 0;

    &.product--row {
        flex-direction: row;
        margin: 0;
        flex: 1 1 100%;
        border-right: 0;
        .add-cart__container {
            text-align: left;
        }
        .product__image {
            flex: 50%;
            padding: 0 1rem 0 0;
            margin-bottom: 0;
            flex: 50%;
            padding: 0 1rem 0 0;
            margin-bottom: 0;

            @media (max-width: 980px) {
                flex: 30%;
            }
        }
        .product__name {
            padding: 0;
            margin-top: 0;
        }
        .product__desc {
            -webkit-line-clamp: 3;
        }
        .product__content {
            flex: 50%;
            text-align: left;
            align-items: baseline;
        }
    }

    &__desc {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 42px;
    }

    &__gift {
        //padding: 0.75em 0 0;

        @media (min-width: 480px) {
            //padding: 0.75em 0.5em 0;
        }

        .gift-actions {
            display: flex;
            align-items: center;
        }

        .ico {
            display: none !important;
            flex: 0 0 16px;
        }

        strong {
            color: #146154;
        }

        span {
            display: -webkit-box;
            max-width: 100%;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            font-size: 13px;

            @media (min-width: 480px) {
                -webkit-line-clamp: 1;
            }
        }
    }

    .counter {
        display: none !important;
    }

    .add-cart__container {
        text-align: center;
    }

    .cover-link {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &:hover {
        @media (min-width: 1024px) {
            box-shadow: 0 1px 6px #94aab34c;
            transition: 150ms ease-in-out;
        }
    }

    &__content {
        margin-top: 20px; //place for stars
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 50%;
        text-align: left;
        align-items: baseline;
    }

    .add-cart {
        width: 100%;
        max-width: 160px;
        margin: 0 auto;
    }

    .add-cart__simple {
        white-space: nowrap;
        width: 100%;
        max-width: 140px;
        padding: 3px 20px 5px;
    }

    &__image {
        position: relative;
        margin-bottom: 25px;

        img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
            width: auto;
        }
    }

    &__name {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        margin: 5px 0;
        overflow: hidden;
        white-space: pre-wrap;

        .h3 {
            font-size: 14px;
            line-height: 16px;
            text-decoration: none;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 0;
        }
    }

    &__availability {
        font-size: 13px;
        padding: 5px 0;
        cursor: pointer;
    }

    &__price {
        color: #146154;
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 700;
        &:hover {
            color: #146154;
        }
        b {
            font-weight: 700;
        }
        .old {
            font-weight: normal;
            color: #333333;
            font-size: 14px;
            margin-right: 0.5em;
        }
    }

    .add-cart__change {
        border-radius: 50px;
        width: 31px;
        min-width: 31px;
        height: 31px;
        line-height: 26px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .btn-minus {
        color: #146154;
    }

    .alert-addcart {
        display: flex;
        justify-content: center;
        position: absolute;
        left: 0;
        bottom: calc(100% - 150px);
        color: #333;
        padding: 0 0.5em;

        @media (min-width: 980px) {
            width: 100%;
            bottom: calc(100% - 190px);
        }

        & > div {
            font-size: 13px;
            display: inline-block;
            background-color: rgba(233, 235, 178, 0.8);
            border-radius: 10px;
            padding: 0.5em 1em;
            border-radius: 10px;
            font-weight: 500;
            text-align: center;
        }
    }

    &.product--row .alert-addcart {
        bottom: calc(100% - 165px);
        width: 45%;

        @media (min-width: 980px) {
            bottom: calc(100% - 185px);
        }
    }
}

.img-container {
    position: relative;
    height: 120px;
    display: block;
    padding-top: 50%;

    @media (min-width: 576px) {
        height: 160px;
    }
}

.template-stars--productList {
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: -50px;
    right: 0;
}

.product--row .template-stars--productList {
    right: auto;
    bottom: -70px;

    @media (min-width: 576px) {
        bottom: -50px;
    }
}
// AddRating hidden for carousels (no api endPoint)
.noRating {
    .product__content {
        margin-top: 0;
    }
    .addratings {
        display: none;
    }
}
.product-poster .product__image {
    img {
        height: auto;
        width: auto;
        max-width: 100%;
        max-height: 100%;
    }
}
</style>
